import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer 
      className="py-8 px-4 text-white" 
      data-testid="main-footer"
      style={{
        background: 'linear-gradient(180deg, #14b8a6 0%, #40E0D0 100%)'
      }}
    >
      <div className="container mx-auto">
        <div className="grid md:grid-cols-4 gap-6 mb-6">
          {/* Logo & Company Name */}
          <div>
            <img 
              src="https://beratung.grossstadtherzen.de/logo-transparent.png" 
              alt="Großstadtherzen Logo" 
              className="h-20 w-auto mb-2"
              data-testid="footer-logo"
            />
            <p className="text-sm text-white">
              Ambulante Pflege Großstadtherzen Leipzig und Halle (Saale)
            </p>
          </div>
          
          {/* Leipzig */}
          <div>
            <h4 className="font-bold text-white mb-3">Leipzig</h4>
            <ul className="space-y-1 text-sm">
              <li><Link to="/leipzig" className="hover:text-gray-100 transition-colors">Startseite</Link></li>
              <li><Link to="/leipzig/ueber-uns" className="hover:text-gray-100 transition-colors">Über uns</Link></li>
              <li><Link to="/leipzig/freie-kapazitaeten" className="hover:text-gray-100 transition-colors">Freie Kapazitäten</Link></li>
              <li><Link to="/leipzig/stellenausschreibung" className="hover:text-gray-100 transition-colors">Karriere</Link></li>
            </ul>
          </div>
          
          {/* Halle (Saale) */}
          <div>
            <h4 className="font-bold text-white mb-3">Halle (Saale)</h4>
            <ul className="space-y-1 text-sm">
              <li><Link to="/halle" className="hover:text-gray-100 transition-colors">Startseite</Link></li>
              <li><Link to="/halle/ueber-uns" className="hover:text-gray-100 transition-colors">Über uns</Link></li>
              <li><Link to="/halle/freie-kapazitaeten" className="hover:text-gray-100 transition-colors">Freie Kapazitäten</Link></li>
              <li><Link to="/halle/karriere" className="hover:text-gray-100 transition-colors">Karriere</Link></li>
            </ul>
          </div>
          
          {/* Rechtliches & Allgemein */}
          <div>
            <h4 className="font-bold text-white mb-3">Rechtliches</h4>
            <ul className="space-y-1 text-sm mb-4">
              <li><Link to="/impressum" className="hover:text-gray-100 transition-colors">Impressum</Link></li>
              <li><Link to="/datenschutz" className="hover:text-gray-100 transition-colors">Datenschutz</Link></li>
            </ul>
            <h4 className="font-bold text-white mb-3">Allgemein</h4>
            <ul className="space-y-1 text-sm">
              <li><Link to="/leistungen" className="hover:text-gray-100 transition-colors">Leistungen</Link></li>
              <li><Link to="/kontakt" className="hover:text-gray-100 transition-colors">Kontakt</Link></li>
            </ul>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="border-t border-white/20 pt-4 text-center text-sm">
          <p className="text-white">© 2025 Ambulante Pflege Großstadtherzen® UG. Alle Rechte vorbehalten.</p>
          <div className="mt-2">
            <Link 
              to="/portal-gsh" 
              className="opacity-0 select-none cursor-default text-xs"
              aria-hidden="true"
              tabIndex={-1}
              data-testid="admin-login-link"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
